import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../../NewHeader/Layout';
import './paymentreport.css';
import { var_api } from '../../constant';
import Pagination from 'react-js-pagination';


const PaymentReport = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [creditcustList, setCreditCustList] = useState([]);
  const [ searchQuery,setSearchQuery] = useState('');
  const [ isEdit,setIsEdit ] = useState(false);
  const [ itempopup,setItempopup ] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentRequestId, setCurrentRequestId] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [EmployeeD, setEmployeeD] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); 
  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId")
});
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});



console.log(formData)



useEffect(() => {
  fetctCreditCustList(); // Fetch customer list
}, []);


const fetctCreditCustList= async () => {
  const shop_id = localStorage.getItem('ShopId');
  const token = localStorage.getItem('Token');

  try {
    const response = await axios.get(
      `${var_api}credit-user-request/active-shop-customers/${shop_id}`,
      {
        headers: {
          Authorization: `${token}`, // Add the token to the Authorization header dynamically
        },
      }
    );
    const user = response.data.data;
    setCreditCustList(user);
    if (response.data.data.length > 0) {
      const defaultCustomerId = response.data.data[0].customer_id;
      setSelectedCustomerId(defaultCustomerId);
      fetchTables(defaultCustomerId); // Fetch data for the default customer
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error fetching data:", error);
    }
  }
};

     // Fetch tables data
  const fetchTables = async (newId) => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');

    try {
      const response = await axios.get(
        // `${var_api}credit-history/payment-history/${newId}`,
        `${var_api}credit-user/payment-history/${shop_id}/${newId}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      const user = response.data.data;
      setTables(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };
      

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      const paymentStatusText = order.is_paid === 0 ? "Not Paid" : "Paid";
      return (
        (order.credit_limit && order.credit_limit.toString().toLowerCase().includes(searchLower)) ||
        (order.paid_amount && order.paid_amount.toString().toLowerCase().includes(searchLower))  ||
        (order.outstanding_amount && order.outstanding_amount.toString().toLowerCase().includes(searchLower))  ||
        (order.due_date && order.due_date.toString().toLowerCase().includes(searchLower)) ||
        (order.paid_date && order.paid_date.toString().toLowerCase().includes(searchLower)) ||
        (order.total_date && order.total_date.toString().toLowerCase().includes(searchLower)) ||
        paymentStatusText.toLowerCase().includes(searchLower) 
      );
    });

    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };

    // Logic to slice the filtered tables based on the pagination
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
// Ensure filteredSuppliers is an array before slicing
const currentTables = Array.isArray(filteredSuppliers)
  ? filteredSuppliers.slice(indexOfFirstItem, indexOfLastItem)
  : [];

  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

    //get the value in search and set the setstate
    const handleSearchInput = (e) => {
      setSearchQuery(e.target.value)
      };


  const handleDropdownChange = (event) => {
    const newId = event.target.options[event.target.selectedIndex].getAttribute(
      "data-id"
    );
    console.log("newId", newId, event.target.value);
    setSelectedId(newId);
    fetchTables(newId);
  };

  const handleItempopup = (data) => {
    // setApprovalStatus(status === "enable" ? 1 : 0); // Set the status dynamically
    setCurrentRequestId(data); // Store the current credit_request_id
    setShowModal(true); // Open the modal
    setRemarks(data.total_amount);
  };

  const handleConfirm = async () => {
    try {
      const token = localStorage.getItem("Token");
       // Format current date as dd-mm-yyyy
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
      // const payload = {
      //   approval_status: approvalStatus,
      //   rejected_remarks: remarks,
      // };

      const payload = {
        is_paid: 1,
        paid_amount: parseInt(remarks),
        paid_date: formattedDate,
      };

      await axios.put(
        // `${var_api}credit-user-request/approval-put/${currentRequestId}`,
        `${var_api}credit-user-request/put/${currentRequestId.id}`,
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      Swal.fire("Payment updated successfully!");
      setShowModal(false);
      fetctCreditCustList();
      // Refresh the table data or update state to reflect the changes
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error update credit request data:", error);
      }
    }
  };
  

    return(
      <>         <Layout>

      

            <div class="splitpr">
          
      <div style={{border:"none",padding:"20px",width:"100%",height:"auto",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>    
    {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"18px",float:"right",borderRadius:"15px"}}>Create Blocked Slot</Button>{' '} */}
    
    <div>
    <div className="row">
  <div className="col">
    <h4 className="ushecpr">PAYMENT HISTORY</h4>
  </div>
  
  <div className="col d-flex justify-content-end align-items-center" >
    <div style={{ maxWidth: "250px", position: "relative",marginRight:"15px" }}>
    <select
        className="itSelect m-0 p-0 mb-2"
        aria-label="Default select example"
        required
        onChange={handleDropdownChange}
      >
        {creditcustList.length > 0 ? (
        creditcustList.map((names) => (
          <option
            value={names.customer_name}
            key={names.customer_id}
            data-id={names.customer_id}
          >
            {names.customer_name}
          </option>
           ))
          ) : (
            <option value="" disabled>
              No customers available
            </option>
          )}
      </select>
      {/* <i
        className="bi bi-chevron-down"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "gray",
        }}
      ></i> */}
    </div>

    <input
      className="form-control"
      type="search"
      placeholder="Search"
      style={{
        maxWidth: "230px",
        border: "1px solid black",
        borderRadius: "12px",
      }}
      onChange={handleSearchInput}
    />

{/* {tables.map((table) => (
        <div key={table.id} className="button-group">
          {table.approval_status === 1 ? (
            <Button
              variant="danger"
              size="sm"
              style={{ padding: "2px 8px", fontSize: "17px", marginLeft: "10px" }}
              onClick={() => handleItempopup("disable",table.credit_request_id)}
            >
              Disable
            </Button>
          ) : (
            <Button
              variant="success"
              size="sm"
              style={{ padding: "2px 8px", fontSize: "17px", marginLeft: "10px" }}
              onClick={() => handleItempopup("enable",table.credit_request_id)}
            >
              Enable
            </Button>
          )}
        </div>
      ))} */}
  </div>
</div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll', marginTop:"10px" }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">customer_name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Email</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Due Date</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Credit Limit</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Used Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Outstanding Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Paid Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Paid Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Paid Date</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody class="body-half-screen">
   {currentTables && currentTables.length > 0 ? (
   currentTables && currentTables.map((data,index) =>(

    <tr style={{padding:"4px"}}>
      <th scope="row" style={{textTransform:"capitalize",textAlign:"left"}}>{indexOfFirstItem +index + 1}</th>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.customer_name}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.email_id}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.mobile_no}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.due_date}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.credit_limit}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.total_amount}</td> 
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.outstanding_amount}</td> 
      <td style={{textTransform:"capitalize",textAlign:"left", color: data.is_paid == 0 ? "red" : data.is_paid == 1 ? "green" : "grey"}}>{data.is_paid == 0 ? "Not Paid" : data.is_paid == 1 ? "Paid" : "Pending"}</td>   
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.paid_amount || 0}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.paid_date}</td>                            
      <td>
      <div style={{ textTransform: "capitalize", textAlign: "left", display: "flex", gap:"2px"}}>         
        <Button variant='success' size="sm" style={{ padding: "2px 8px", fontSize: "17px" }}  onClick={() =>handleItempopup(data)} disabled={data.is_paid == 1}>Pay</Button>
      </div>
      </td>
    </tr>
       ))
   ) : (
    <tr>
      <td colSpan="12" style={{ textAlign: "center", color:"red", fontWeight:"bold", borderColor:"black" }}>
        No Data Available
      </td>
    </tr>
   )}
 

   </tbody>
}
</table>
<br/>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={currentTables.length}  // Use filteredTables length
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />

      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"22px"}}>
          {/* <Modal.Title>confirmation</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Blocked Credit Customer 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
      
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
           Confirm Payment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="remarks">
              <Form.Label>Amount</Form.Label>
              <Form.Control
              type="number"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Enter amount here..."
              min="0.1"
              step="0.1"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirm to pay
          </Button>
        </Modal.Footer>
      </Modal>
            {/* </div> */}
       </Layout></>

        
    )
}

export default PaymentReport;